'use client'
import { useCallback, useEffect, useRef } from 'react'

const THRESHOLD_NORMAL_MS = 6 * 60 * 60 * 1000
const THRESHOLD_NIGHT_MS = 2 * 60 * 60 * 1000
const POLL_INTERVAL_MS = 60_000
const NIGHT_START = 0
const NIGHT_END = 6

const getMadridHour = (): number => {
	const formatter = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', hour: 'numeric', hour12: false })
	return parseInt(formatter.format(new Date()), 10)
}

const getActiveThreshold = (): number => {
	const hour = getMadridHour()
	return hour >= NIGHT_START && hour < NIGHT_END ? THRESHOLD_NIGHT_MS : THRESHOLD_NORMAL_MS
}

export const InactivityManager = () => {
	const lastActivityRef = useRef<number>(0)
	const hasTriggeredRef = useRef<boolean>(false)
	const intervalRef = useRef<ReturnType<typeof setInterval>>(null)

	const triggerInactivityAlert = useCallback(() => {
		console.log('Inactivity detected')
	}, [])

	const handleActivity = useCallback(() => {
		lastActivityRef.current = Date.now()
		hasTriggeredRef.current = false
	}, [])

	useEffect(() => {
		lastActivityRef.current = Date.now()
		document.addEventListener('click', handleActivity)
		document.addEventListener('keydown', handleActivity)

		intervalRef.current = setInterval(() => {
			if (hasTriggeredRef.current) return
			const elapsed = Date.now() - lastActivityRef.current
			if (elapsed >= getActiveThreshold()) {
				hasTriggeredRef.current = true
				triggerInactivityAlert()
			}
		}, POLL_INTERVAL_MS)

		return () => {
			document.removeEventListener('click', handleActivity)
			document.removeEventListener('keydown', handleActivity)
			clearInterval(intervalRef.current)
		}
	}, [handleActivity, triggerInactivityAlert])

	return null
}
